import AchievementsDataset from "../../components/game-views/datasets/achievements_dataset";

const determineCelebrationText = (medalType, achievementID) => {
    let insertText = "";
    let typeText = " medal.";
    switch (medalType){
        case "Bronze":
            insertText = "cool";
            break;
        case "Silver":
            insertText = "awesome";
            break;
        case "Gold":
            insertText = "incredible";
            break;
        case "Jewel":
            insertText = "amazing";
            typeText = ".";
            break;
        default:
            break;
    }
    let additionalText = "Congratulations!! You've done something " + insertText + " and earned a " +
        medalType + typeText;
         
    const achieveInfoObj = AchievementsDataset.find(elem => elem.achievementID === achievementID);
    if (achieveInfoObj){
        const earnedAchievementText = achieveInfoObj.earnedAchievementDesc;
        additionalText += " " + earnedAchievementText;
    }
     
    if (medalType === "Jewel"){
        additionalText += " You now have bragging rights!"
    }
    return additionalText;
}
export default determineCelebrationText;